import PropTypes from 'prop-types';
import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import Immutable from 'immutable';
import _ from 'lodash';
import moment from 'moment';
import momentPropTypes from 'react-moment-proptypes';

import { getZoneOccupancy } from 'actions/query';
import { QUERY_DATE_FMT } from '../../constants';

const fmtTimeParam = x => ((x instanceof moment) ? x.format(QUERY_DATE_FMT) : x);

const DEFAULT_RESPONSE = {
  resolved: true,
  failed: false,
  error: null,
  response: {
    content: {
      rows: [],
    },
  },
};

const provider = opts => (WrappedComponent) => {
  let options = {};
  let applied = false;

  class Model extends PureComponent {
    constructor(props) {
      super(props);
      const parameters = this.getParameters(props);
      const { dispatch, name } = this.props;

      if (parameters.get('zoneId')) {
        dispatch(getZoneOccupancy(name, parameters.get('endpoint'), parameters.get('zoneId'),
          parameters.get('startTime'),
          parameters.get('endTime'),
          parameters.get('dimensions').toJS()));
      }

      this.state = {
        parameters,
      };
    }

    componentWillReceiveProps(nextProps) {
      const { parameters } = this.state;
      const newParameters = parameters.mergeDeep(this.getParameters(nextProps));
      if (newParameters !== parameters && !!newParameters.get('zoneId')) {
        const { dispatch, name } = nextProps;
        dispatch(getZoneOccupancy(name, newParameters.get('endpoint'), newParameters.get('zoneId'),
          newParameters.get('startTime'),
          newParameters.get('endTime'),
          newParameters.get('dimensions').toJS()));

        this.setState({ parameters: newParameters });
      }
    }

    getDownloadURL() {
      const { parameters } = this.state;
      const { name } = this.props;
      const action = getZoneOccupancy(name, 'occupancy.csv', parameters.get('zoneId'),
        parameters.get('startTime'),
        parameters.get('endTime'),
        parameters.get('dimensions').toJS());
      return action.payload.request.url;
    }

    getParameters(props) {
      const {
        startTime, endTime, dimensions, zoneId, endpoint,
      } = props;
      return Immutable.Map({
        startTime: fmtTimeParam(startTime),
        endTime: fmtTimeParam(endTime),
        dimensions: Immutable.List(_.isArray(dimensions) ? dimensions : [dimensions]),
        zoneId,
        endpoint: endpoint || 'occupancy',
      });
    }

    render() {
      const {
        prefix,
        data: {
          response, resolved, failed, error,
        },
        props,
      } = this.props;
      const { parameters } = this.state;
      const noZoneId = !parameters.get('zoneId');

      let propsToPass = noZoneId ? {
        fetching: false,
        result: { content: { rows: [] } },
        error: null,
        failed: null,
      } : {
        fetching: parameters === null ? true : !resolved,
        result: parameters === null ? null : response,
        error: parameters === null ? null : error,
        failed: parameters === null ? false : failed,
      };
      if (prefix) {
        propsToPass = {
          ..._(propsToPass)
            .chain()
            .toPairs()
            .map(x => [`${prefix || ''}${x[0]}`, x[1]])
            .fromPairs()
            .value(),
        };
      }
      return <WrappedComponent {...{ ...propsToPass, ...props }} />;
    }
  }
  Model.propTypes = {
    prefix: PropTypes.string,
    dispatch: PropTypes.func,
    // eslint-disable-next-line react/forbid-prop-types
    props: PropTypes.any,
    startTime: PropTypes.oneOfType([PropTypes.string, momentPropTypes.momentObj]),
    endTime: PropTypes.oneOfType([PropTypes.string, momentPropTypes.momentObj]),
    data: PropTypes.shape({
      response: PropTypes.any,
      resolved: PropTypes.bool,
      failed: PropTypes.bool,
      error: PropTypes.any,
    }),
  };
  return connect((state, props) => {
    if (_.isFunction(opts) || !applied) {
      options = {
        ...options,
        ...(_.isFunction(opts) ? opts(props) : opts),
      };
      applied = true;
    }
    const hasZoneId = !!options.zoneId;
    if (!options.name && hasZoneId) {
      throw new Error('`name` was not defined in options to OccupancyProvider');
    }
    const data = (() => {
      if (hasZoneId) {
        return state.zoneOccupancy[options.name] || { resolved: false };
      }
      return DEFAULT_RESPONSE;
    })();
    return {
      data,
      startTime: options.startTime,
      endTime: options.endTime,
      dimensions: options.dimensions,
      zoneId: options.zoneId,
      prefix: options.prefix,
      endpoint: options.endpoint,
      name: options.name,
      props,
    };
  }, null, null, { withRef: true })(Model);
};

export default provider;
